define([], function() {
    return {
        TASK_SAVE: 'modal_task_popup:save',
        TASK_DELETE: 'modal_task_popup:delete',
        TASK_CANCEL: 'modal_task_popup:cancel',
        TASK_DURATION_FILTER_CHANGE: 'task-duration-filter-change',
        TASK_STATUS_FILTER_CHANGE: 'task-status-filter-change',
        TASK_SEARCH_FILTER_CHANGE: 'input',
        MANAGE_COURSES_DISPLAY_FILTER_CHANGE: 'manage-course-display-filter-change',
        MANAGE_COURSES_PAGE_FILTER_CHANGE: 'manage-course-page-filter-change',
        MANAGE_COURSES_PAGINATE: 'manage-course-paginate',
        COURSE_ANALYTICS_PAGE_FILTER_CHANGE: 'course-analytics-page-filter-change'
    };
});
